import React, { Component } from 'react';
import { Router, IndexRoute, Route } from 'react-router';
import ChoiceBox from '../ChoiceBox/ChoiceBox';

const MultipleAnswer = React.createClass({

    render() {

        const name = this.props.name;
        const value = this.props.value;
        const type = this.props.type || 'radio';
        const disabled = this.props.disabled;

        console.log("Hello");

        return(
            <ChoiceBox
                type={type}
                value={value}
                name={name}
                label={this.props.children}
                onSelect={this.props.onSelect}
                className={this.props.className}
                disabled={disabled}
                labelToRight
            />
        );
    }
});

export default MultipleAnswer;


/** WEBPACK FOOTER **
 ** ./src/components/ExerciseMultipleAnswer/ExerciseMultipleAnswer.js
 **/